import { styled } from '@mui/material/styles';

export const StyledPriceWrapper = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    justifyContent: 'flex-start',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-end',
    },
  };
});

export const StyledActionButtonWrapper = styled('div')(({ theme }) => {
  return {
    padding: '12px 0 0 0',
    [theme.breakpoints.up('md')]: {
      padding: '0 0 0 16px',
    },
  };
});
